import script from "./FlashMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./FlashMessage.vue?vue&type=script&setup=true&lang=js"

import "./FlashMessage.vue?vue&type=style&index=0&id=d9000dea&lang=scss"

const __exports__ = script;

export default __exports__